import EF from 'ef/ef';
import CollectionView from 'views/base/collection-view';
import CourseMapTemplate from './templates/course-map';
import CourseModuleView from 'developer/views/toolbar/course-module-view';
import SurveyView from 'developer/views/toolbar/survey-view';
import AssessmentView from 'developer/views/toolbar/assessment-view';

const CourseMapView = CollectionView.extend({
  template: CourseMapTemplate,
  itemView: CourseModuleView,
  listSelector: '#accordion',
  autoRender: true,
  regions: {
    survey: '#survey_pane',
    assessment: '#assessment_pane',
  },
  listen: {
    addedToDOM: 'loaded',
  },
  loaded: function () {
    if (EF.options.local) {
      const surveyView = new SurveyView({
        region: 'survey',
      });
      this.subview('survey', surveyView);

      const assessmentView = new AssessmentView({
        region: 'assessment',
      });
      this.subview('assessment', assessmentView);
    }
  },
  getTemplateData: function () {
    return {
      local: EF.options.local,
    };
  },
});

export default CourseMapView;
